// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__vTj_o","table":"styles_table__Xc2je","tableVerticalHeader":"styles_tableVerticalHeader__ZCehY"};